import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { ImWhatsapp } from "react-icons/im";
import "../components/styles.css";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col bg-gray-100 min-h-screen">
      <Header />
      <div className="flex-1">
        <div className="">{children}</div>
      </div>
      <Footer />
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://api.whatsapp.com/send?phone=5519993820824&text=Ol%C3%A1!%20Tenho%20interesse."
        className="cursor-pointer  animate-bounce   fixed"
        style={{ bottom: 75, right: 25 }}
      >
        <div className="flex items-center">
          <div className="bg-green-500 h-6 text-white px-2 rounded-full">
            Atendente Disponível!
          </div>
          <div className="rounded-full p-1 bg-green-500 text-4xl text-white">
            <ImWhatsapp></ImWhatsapp>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Layout;
